<template>
    <v-layout row wrap>
        <v-flex xs6 md4 v-for="k in activeKPI">
            <value-box :unit="k.unit"
                       :value="k.kpi_value"
                       icon=""
                       has-comma
                       :title="k.kpi_name"
                       >
            </value-box>
        </v-flex>
    </v-layout>

</template>

<script>
  import ValueBox from '../ValueBox'
  import {getKPI} from '@/helper'

  export default {
    name: 'KPIValueBoxes',
    components: { ValueBox },
    data () {
      return {
        KPI: []
      }
    },
    computed: {
      activeKPI () {
        return this.KPI.filter(x => x.show_flag)
      }
    },
    methods: {
      async refresh() {
        let res = await getKPI(
          {'facility_name': this.$store.state.pointsListStore.pointsList.facility_name}
        )
        this.KPI = res['result']
      }
    },
    mounted () {
      this.refresh()
    }

  }
</script>
